module.exports = __webpack_public_path__ + "img/acondicionado.81f6da94.svg";